import { SubtenantsSelectors } from 'invision-core';
import { createSelector } from 'reselect';
export var CurrentBusinessUnitHasSubtenants = createSelector([SubtenantsSelectors.SubtenantsSelector], function (subtenants) {
  return subtenants ? subtenants.length > 0 : false;
});